import * as React from "react";
import { Link } from 'react-router-dom';
import {Button, useShowContext} from "react-admin";
import { Box } from "@mui/material"; 
import { Add } from "@mui/icons-material";

const AddImprovementsButton = (props) => {
    const {record} = useShowContext();

    return (
        <Box mt={1} mb={1}>
            <Button
                variant="contained"
                component={Link}
                to={{
                    pathname: "/improvements/create",
                    state: {record: {assessmentId: record.id}},
                }}
                label="Add Improvements"
            >
                <Add/>
            </Button>
        </Box>
    );
};

export default (AddImprovementsButton);